export const kelvinsToCelsius = degrees => {
    const kelvin = 273.15;
    return degrees - kelvin;
}